import React from 'react';
import SOIMatchEventListItem from '../list/SOIMatchEventListItem';

/**
 * SOIMatchEvent - Renders an individual SOI match event
 */
function SOIMatchEvent({
  match,
  onEventClick,
  onDeleteClick,
  disabled
}) {
  return (
    <SOIMatchEventListItem
      event={match}
      onClick={onEventClick}
      onDelete={onDeleteClick}
      disabled={disabled}
    />
  );
}

export default React.memo(SOIMatchEvent);
